import { render, staticRenderFns } from "./sapPurchaseForecast-add-or-update.vue?vue&type=template&id=6e1a6afb&scoped=true"
import script from "./sapPurchaseForecast-add-or-update.vue?vue&type=script&lang=js"
export * from "./sapPurchaseForecast-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./sapPurchaseForecast-add-or-update.vue?vue&type=style&index=0&id=6e1a6afb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1a6afb",
  null
  
)

export default component.exports